import WildLifeSpecies from './wildlife_species';

export default WildLifeSpecies;
